export var paymentTypeOfLink = [
    {
        value: 'All',
        display: 'All',
    },
    {
        value: 'Active',
        display: 'Active',
    },
    {
        value: 'Inactive',
        display: 'Inactive',
    }
];
